import { apiClient } from './api';
import { Bus, CreateBusRequest, UpdateBusRequest, ApiResponse } from '../types';

class BusesService {
  private endpoint = '/admin/buses';

  /**
   * Fetch all buses
   */
  async getBuses(): Promise<Bus[]> {
    try {
      const response = await apiClient.get<any>(this.endpoint);
      return response.data.buses || [];
    } catch (error) {
      console.error('Error fetching buses:', error);
      throw error;
    }
  }

  /**
   * Fetch a single bus by ID
   */
  async getBus(busId: string): Promise<Bus> {
    try {
      const response = await apiClient.get<any>(
        `${this.endpoint}/${busId}`
      );
      if (!response.data) {
        throw new Error('Bus not found');
      }
      return response.data;
    } catch (error) {
      console.error('Error fetching bus:', error);
      throw error;
    }
  }

  /**
   * Create a new bus
   */
  async createBus(request: CreateBusRequest): Promise<Bus> {
    try {
      const response = await apiClient.post<any>(
        this.endpoint,
        request
      );
      if (!response.data) {
        throw new Error('Failed to create bus');
      }
      return response.data;
    } catch (error) {
      console.error('Error creating bus:', error);
      throw error;
    }
  }

  /**
   * Update a bus
   */
  async updateBus(busId: string, request: UpdateBusRequest): Promise<Bus> {
    try {
      const response = await apiClient.put<any>(
        `${this.endpoint}/${busId}`,
        request
      );
      if (!response.data) {
        throw new Error('Failed to update bus');
      }
      return response.data;
    } catch (error) {
      console.error('Error updating bus:', error);
      throw error;
    }
  }

  /**
   * Delete a bus
   */
  async deleteBus(busId: string): Promise<void> {
    try {
      await apiClient.delete(`${this.endpoint}/${busId}`);
    } catch (error) {
      console.error('Error deleting bus:', error);
      throw error;
    }
  }
}

export const busesService = new BusesService();
